const FETCH_WAGES = 'fetch_wages';
const FETCH_WAGE = 'fetch_wage';
const DELETE_WAGE = 'delete_wage';
const PERSIST_WAGE = 'persist_wage';
export default {
    FETCH_WAGES,
    FETCH_WAGE,
    DELETE_WAGE,
    PERSIST_WAGE,
};
